module.exports = __webpack_public_path__ + "img/rna.a4e34600.png";